/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Course_Addchapter1Inputs */

const zh_course_addchapter1 = /** @type {(inputs: Course_Addchapter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加章节`)
};

const en_course_addchapter1 = /** @type {(inputs: Course_Addchapter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add Chapter`)
};

const es_course_addchapter1 = /** @type {(inputs: Course_Addchapter1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Añadir capítulo`)
};

/**
* | output |
* | --- |
* | "Add Chapter" |
*
* @param {Course_Addchapter1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const course_addchapter1 = /** @type {((inputs?: Course_Addchapter1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Course_Addchapter1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_course_addchapter1(inputs)
	if (locale === "en") return en_course_addchapter1(inputs)
	return es_course_addchapter1(inputs)
});
export { course_addchapter1 as "course_addChapter" }